import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import useCacheBuster from './UseCacheBuster'
import { get, set } from 'idb-keyval'
import { useAuth } from '../app-context/AuthContext'
import rolesConstants from '@/config/constants/RolesConstants'

const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress']

const rolesLogout = [rolesConstants.ROLE_FINALCUSTOMER]

const AppCacheAndLogout = ({ children, roles }) => {
  useCacheBuster()
  const timerRef = useRef(null)
  const navigate = useNavigate()
  const { logout } = useAuth()

  useEffect(() => {
    const initCache = async () => {
      await set('role', roles[0])

      if (rolesLogout.includes(roles[0])) {
        // Iniciar el timer cuando el componente monta
        resetTimer()

        // Añadir los event listeners
        events.forEach((event) => {
          window.addEventListener(event, resetTimer)
        })
      }
    }

    initCache()

    // Cleanup cuando el componente se desmonta o roles cambia
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer)
      })
    }
  }, [roles]) // Dependencia en roles para reiniciar cuando cambie

  const resetTimer = async () => {
    // Limpiar el timer anterior
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    // Verificar si el rol actual debe tener logout automático
    const currentRole = await get('role')

    if (rolesLogout.includes(currentRole)) {
      // Crear un nuevo timer
      timerRef.current = setTimeout(() => {
        logoutAction()
      }, 1200000) // 5 segundos para pruebas, cambiar a 1200000 para 20 minutos
    }
  }

  const logoutAction = async () => {
    const role = await get('role')

    // Solo hacer logout si el rol está en la lista de rolesLogout
    if (rolesLogout.includes(role)) {
      // Limpiar event listeners antes de hacer logout
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer)
      })

      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }

      logout()
      navigate('/')
    }
  }

  return children
}

export default AppCacheAndLogout
